// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3oI8e","label":"Category_label__2yu5q","content":"Category_content__2qZy8","header":"Category_header__389Bu","location":"Category_location__2YX3K"};